<template>
  <div>
    <p class="lead">
      The requested resource could not be found.
    </p>
    <p>
      If you have any questions, please <a href="/contact">contact us</a>.
    </p>
  </div>
</template>

<script>
export default {};
</script>
